var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"mr-1 my-1 pa-1 font-weight-bold",attrs:{"color":"background","text-color":"accent","label":"","x-small":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }